import React from 'react';

import { classnames } from '@/utils/classnames.ts';

// The bar across the top of a frame, above the page: where it is (the workspace and its crumbs), in the app as on a
// public link. It stays at the top while the page scrolls under it, in the appearance's colour for it (`--color-top`,
// plan task 120), see-through by `--top-bar-opacity`, which also applies where its colour is set elsewhere (the colour
// experiment's surfaces for the bar).
const TopBar = ({ className, ...props }: React.ComponentPropsWithRef<'header'>) => (
    <header
        {...props}
        className={classnames(
            'sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 border-b select-none border-border bg-[color-mix(in_srgb,var(--color-top)_var(--top-bar-opacity),transparent)] px-4 backdrop-blur-md [--top-bar-opacity:80%] md:px-8',
            className
        )}
    />
);

export default TopBar;
